import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-not-logged-in',
  templateUrl: './layout-not-logged-in.component.html',
  styleUrls: ['./layout-not-logged-in.component.css']
})
export class LayoutNotLoggedInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/layout-not-logged-in/layout-not-logged-in.component.ts